import { Form, InputNumber } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketMetaField } from "../../../../../../administration/ticket_creation/types/field_configs/Meta";

type Props = {
  field: Extract<TicketMetaField, { type: "number" }>;
  name: string;
};

export const NumberInput = observer((props: Props) => {
  return (
    <Form.Item
      name={props.name}
      label={props.field.label}
      help={props.field.description}
    >
      <InputNumber min={props.field.min} max={props.field.max} />
    </Form.Item>
  );
});
